import type { IAssetTemplateAssigned } from '../types';

import { useCallback, useMemo, useState } from 'react';
import { sortByCondition } from '~/utils';

export interface IAssetTemplateAssignedFilterResult {
  queryValue: string | undefined;
  allPageAssignedDataIds: string[];
  pageAssignedData: IAssetTemplateAssigned[];
  handleQueryValueRemove: () => void;
  handleFiltersQueryChange: (value: string) => void;
}
export const useInitializeAssetTemplateAssignedFilter = (
  listItems: IAssetTemplateAssigned[],
): IAssetTemplateAssignedFilterResult => {
  const [queryValue, setQueryValue] = useState<string | undefined>(undefined);

  const allPageAssignedDataIds = useMemo(() => listItems.map((item) => item.id), [listItems]);
  const pageAssignedFilter = useMemo(() => {
    const query = queryValue?.trim().toLowerCase() || '';
    if (!query) return listItems;

    return listItems.filter(
      (item) =>
        item.fullPath.toLowerCase().includes(query) ||
        item.title.toLowerCase().includes(query) ||
        item.id.includes(query),
    );
  }, [listItems, queryValue]);
  const pageAssignedData = useMemo(
    () =>
      sortByCondition(pageAssignedFilter, {
        attr: 'updatedAt',
        order: 'asc',
      }),
    [pageAssignedFilter],
  );

  const handleFiltersQueryChange = useCallback((value: string) => {
    setQueryValue(value);
  }, []);

  const handleQueryValueRemove = useCallback(() => {
    setQueryValue(undefined);
  }, []);

  return {
    queryValue,
    pageAssignedData,
    allPageAssignedDataIds,
    handleFiltersQueryChange,
    handleQueryValueRemove,
  };
};
